// modifer: styles/jss/nextjs-material-kit-pro/pages/aboutUsStyle.js
import { page, main, container } from 'styles/jss/original/base';

const styles = {
  page,
  main,
  container
};

export default styles;
